import { render, staticRenderFns } from "./Advise.vue?vue&type=template&id=53405b40&scoped=true&"
import script from "./Advise.vue?vue&type=script&lang=ts&"
export * from "./Advise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53405b40",
  null
  
)

export default component.exports